import { HelpCenterHistory } from '@wix/wix-chatbot-common/browser';
import { useCallback } from 'react';
import { createPath } from 'react-router-dom';

import { getRouterBaseName, trimBaseName } from '../../react-router';
import { getHelpWidgetSession } from '../api/getHelpWidgetSession';
import { updateHelpWidgetSession } from '../api/updateHelpWidgetSession';
import { useFedopsLogger } from '../providers/fedopsLogger';

type GetHelpCenterHistory = () => Promise<HelpCenterHistory>;

const routerBaseName = getRouterBaseName(window.location.pathname);

export const useGetHelpWidgetHistory = (): GetHelpCenterHistory => {
  const fedopsLogger = useFedopsLogger();

  return useCallback(async (): Promise<HelpCenterHistory> => {
    const currentUrlRoute = trimBaseName(
      routerBaseName,
      createPath(window.location),
    );

    fedopsLogger.interactionStarted('fetching-help-center-session');
    // TODO(barstr): Change to resolve - https://app.asana.com/0/1203391152162634/1204549859443275/f
    const helpWidgetSession =
      (await getHelpWidgetSession()) ||
      (await updateHelpWidgetSession({
        addedUrl: currentUrlRoute || '/',
      }));
    fedopsLogger.interactionEnded('fetching-help-center-session');

    return helpWidgetSession?.navigationHistory ?? [];
  }, [fedopsLogger]);
};
